import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Buffer } from "buffer";
import { firstValueFrom } from "rxjs";

@Component({
  selector: "app-restore-journey",
  template: "",
})
export class RestoreJourneyComponent implements OnInit {
  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router
  ) {}

  async ngOnInit() {
    const { connectionId, error, errorDescription, state } =
      await this.getQueryParams();

    const widgetUrlUpdated = this.computeWidgetUrl({
      connectionId,
      state,
      error,
      errorDescription,
    });
    localStorage.setItem("WIDGET_URL", JSON.stringify(widgetUrlUpdated));
    this.router.navigate(["iframe"]);
  }

  private computeWidgetUrl(input: {
    connectionId: string | null;
    state: string | null;
    error: string | null;
    errorDescription: string | null;
  }) {
    const { connectionId, state, error, errorDescription } = input;

    let widgetUrl = JSON.parse(localStorage.getItem("WIDGET_URL") as string) as
      | string
      | null;

    if (!widgetUrl) {
      throw new Error("Widget URL should be defined");
    }

    widgetUrl = this.removeJourneyParams(widgetUrl);

    const openBankingBackendOrigin = JSON.parse(
      localStorage.getItem("OPEN_BANKING_BACKEND_ORIGIN") as string
    );
    const isJourneyFullLocal = openBankingBackendOrigin.includes("localhost");

    if (isJourneyFullLocal) {
      widgetUrl = this.computeWidgetUrlWhenFullLocal({ widgetUrl, state });
    } else {
      widgetUrl = this.computeWidgetUrlDefault({
        widgetUrl,
        connectionId,
        error,
        errorDescription,
        state,
      });
    }

    return widgetUrl;
  }
  private computeWidgetUrlDefault(input: {
    widgetUrl: string;
    connectionId: string | null;
    error: string | null;
    errorDescription: string | null;
    state: string | null;
  }) {
    let { connectionId, state, widgetUrl, error, errorDescription } = input;

    if (connectionId) {
      widgetUrl += `&id_connection=${connectionId}`;
    }

    if (error) {
      widgetUrl += `&error=${error}`;
      if (errorDescription) {
        widgetUrl += `&error_description=${errorDescription}`;
      }
    }

    if (state) {
      widgetUrl += `&state=${state}`;
    }

    return widgetUrl;
  }

  private computeWidgetUrlWhenFullLocal(input: {
    widgetUrl: string;
    state: string | null;
  }) {
    let { state, widgetUrl } = input;
    if (!state) {
      throw new Error("In local a state query param must be provided");
    }

    const { error, id_connection } = JSON.parse(
      Buffer.from(state, "base64").toString("utf-8")
    );

    if (error) {
      widgetUrl += `&error=${error}`;
    }

    if (id_connection) {
      widgetUrl += `&id_connection=${id_connection}`;
    }

    widgetUrl += `&state=${state}`;

    return widgetUrl;
  }

  private async getQueryParams(): Promise<{
    connectionId: string | null;
    error: string | null;
    errorDescription: string | null;
    state: string | null;
  }> {
    const {
      id_connection: connectionId,
      error,
      error_description: errorDescription,
      state,
    } = await firstValueFrom(this.activatedRoute.queryParams);

    return {
      connectionId,
      error,
      errorDescription,
      state,
    };
  }

  private removeJourneyParams(widgetUrl: string): string {
    const url = new URL(widgetUrl);
    ["state", "id_connection", "error", "error_description"].forEach((param) =>
      url.searchParams.delete(param)
    );

    return url.toString();
  }
}
